(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/arena-react/assets/react/arena-app.js') >= 0) return;  svs.modules.push('/modules/arena-react/assets/react/arena-app.js');
'use strict';

const {
  PlayerRouter,
  Route
} = svs.app.ReactRouter;
const {
  GridBase
} = svs.tb_ui_react.gridbase;
const {
  ScrollTopOnNav
} = svs.tb_ui_react.scrollTop;
const {
  ErrorBoundary
} = svs.components.errorBoundary;
const {
  baseUrl
} = svs.core.data;
const {
  routes
} = svs.arena.constants;
const ArenaReduxProvider = svs.arena.store.ArenaReduxProvider;
const {
  Menu
} = svs.arena.shared.components;
const {
  GameGuide,
  Start
} = svs.arena.pages;
const {
  Invite
} = svs.arena.pages.invite;
const {
  Teams,
  TeamsCreate,
  TeamsHistory
} = svs.arena.pages.teams;
const {
  TeamsWaitForBackend
} = svs.arena.pages.teams.components;
const ArenaApp = () => React.createElement(PlayerRouter, {
  basename: baseUrl,
  className: "bg-white",
  withRouter: true
}, React.createElement(ArenaReduxProvider, null, React.createElement(ErrorBoundary, null, React.createElement(Route, {
  exact: true,
  path: routes.HOME,
  render: () => React.createElement(React.Fragment, null, React.createElement(Menu, null), React.createElement(Start, null))
}), React.createElement(ScrollTopOnNav, {
  shouldScrollOnLoad: false
}, React.createElement(Route, {
  exact: true,
  path: routes.TEAMS,
  render: () => React.createElement(React.Fragment, null, React.createElement(Menu, null), React.createElement(Teams, null))
}), React.createElement(Route, {
  exact: true,
  path: routes.TEAMS_CREATE,
  render: () => React.createElement(React.Fragment, null, React.createElement(Menu, null), React.createElement(TeamsCreate, null))
}), React.createElement(Route, {
  exact: true,
  path: routes.TEAMS_INVITATION,
  render: () => React.createElement(React.Fragment, null, React.createElement(Menu, null), React.createElement(Invite, null))
})), React.createElement(Route, {
  exact: true,
  path: routes.HISTORY,
  render: () => React.createElement(React.Fragment, null, React.createElement(Menu, null), React.createElement(GridBase, null, React.createElement(TeamsHistory, null)))
}), React.createElement(Route, {
  exact: true,
  path: routes.GAMEGUIDE,
  render: () => React.createElement(React.Fragment, null, React.createElement(Menu, null), React.createElement(GameGuide, null))
}), React.createElement(Route, {
  exact: true,
  path: routes.TEAMS_WAIT_FOR_BACKEND,
  render: () => React.createElement(React.Fragment, null, React.createElement(Menu, null), React.createElement(TeamsWaitForBackend, null))
}))));
svs.arena.ArenaApp = ArenaApp;

 })(window);